export default __webpack_public_path__ + "static/media/cesar-couto-eIDXdlfelVE-unsplash.215532eb.jpg";